import React from 'react';
import { motion } from 'framer-motion';
import { SunHorizon, Concentric, Figures, Wave, Palm, Compass } from './graphics/Glyphs';
const items = [{
  word: 'urage',
  body: 'For the woman who keeps saying, "I wish I had the courage."',
  Glyph: SunHorizon
}, {
  word: 'nnection',
  body: "Long dinners. Real conversations. Women you'll text for years.",
  Glyph: Figures
}, {
  word: 'mmunity',
  body: 'Eight to ten women. One shared home. A small world on purpose.',
  Glyph: Concentric
}, {
  word: 'uriosity',
  body: 'You do not have to be fearless. You just have to be curious.',
  Glyph: Compass
}, {
  word: 'ulture',
  body: 'A market walk. A pottery wheel. A place from the inside out.',
  Glyph: Palm
}, {
  word: 'nfidence',
  body: 'A surf lesson becomes courage. A pottery class becomes presence.',
  Glyph: Wave
}];
export function CoSpine() {
  return <section id="about" className="bg-paper py-24 md:py-32 px-6 md:px-12" data-id="element-13">
      <div className="max-w-7xl mx-auto" data-id="element-14">
        <div className="text-center mb-16 md:mb-20 max-w-2xl mx-auto" data-id="element-15">
          <p className="eyebrow mb-6" data-id="element-16">What it stands for</p>
          <motion.h2 initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="font-serif-display text-3xl md:text-5xl text-ink leading-[1.1]" data-id="element-17">
            Six words. <span className="italic" data-id="element-18">One small prefix.</span>
          </motion.h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-ink/10 border border-ink/10" data-id="element-19">
          {items.map((item, i) => {
          const Glyph = item.Glyph;
          return <motion.div key={item.word} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.6,
            delay: i % 3 * 0.06
          }} className="bg-paper p-8 md:p-10 flex flex-col" data-id="element-20">
                <div className="w-10 h-10 mb-6 text-ink/65" data-id="element-21">
                  <Glyph className="w-full h-full" animate={false} data-id="element-22" />
                </div>
                <h3 className="font-serif-display text-2xl md:text-3xl text-ink leading-none" data-id="element-23">
                  Co<span className="text-sun italic" data-id="element-24">.</span>
                  <span className="italic text-ink/80" data-id="element-25">{item.word}</span>
                </h3>
                <p className="mt-4 text-ink-soft text-[13px] md:text-[14px] leading-[1.7]" data-id="element-26">
                  {item.body}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}